import type { ApplicationField } from "@wwrp/shared";

export function changeApplicationFieldType(
  field: ApplicationField,
  type: ApplicationField["type"],
): ApplicationField {
  const base = {
    id: field.id,
    label: field.label,
    description: field.description,
    required: field.required,
  };
  if (type === "single_choice" || type === "multi_choice") {
    return { ...base, type, options: "options" in field ? field.options : [] };
  }
  return { ...base, type };
}
